import React from 'react'

const Footer = () => {
  return (
    <div className='text-stone-400 text-sm p-2 text-center mt-2  border-t '>
      ©2025 SEP Admin Panel
    </div>  
  )
}

export default Footer
